import React from 'react';

import { cancel_feedback_path } from '@routes';

const CancelAccount = () => (
  <div className="m-auto max-w-[530px]">
    <p className="cancel">
      If you no longer wish to subscribe to The Information you can{' '}
      <a className="cancel-account" href={cancel_feedback_path()}>
        cancel your account
      </a>
      .
    </p>
  </div>
);

export default CancelAccount;
